export function HeadlineTodayInfoCard({ children }) {
	return <span className="weather-text more__weather-text">{children}</span>;
}
